import React,{useState} from 'react'
import { MomentCaption, StyledBody, StyledModal } from '../../HealthCoach/styles';
import PropTypes from 'prop-types';
// import { Modal } from 'react-bootstrap';
import { Divider } from '../../Manager/styles';
import { AdminDeleteIcon, AdminLeftArrowIcon, CloseIconBranding, DeleteIconBranding, EditIconBranding, MomentsRightArrow, PostButtonIcon, RecognitionWarningIcon } from '../../../utils/icons';
import { SliderContainer, UserInitialsMain, WrapImage } from '../../SocialFeedsV2/styles';
import Slider from 'react-slick';
import {ImageUrl } from "../../../utils/constants";
import { containsDefaultPng, fetchApi } from '../../../utils/methods';
import { ActionContainer, ArrowButton, MomentImageContainer, NewContentV2 } from '../styles';
import { getInitials } from '../../../utils/methods';
import CommonModal from '../../common/CommonModal/CommonModal';
import { DeleteEventMoment } from '../../../redux/constants/apiConstants';
import { toast } from 'react-toastify';

function MomentImagesPopup({showModal, onClose,modalData,userId,setSelectedMoment,setEditMomentModal,  getEventDetailsById,event,companyId,page,getSharedMoments,shareMoment}) {
  const [currentSlide, setCurrentSlide] = useState(0);
  const totalSlides = modalData?.images?.length || 0;
  const[openDeleteModal,setOpenDeleteModal] = useState(false);
  const [momentId,setMomentId] = useState(null);

  const CustomNextArrow = ({ onClick }) => {
    if (currentSlide === totalSlides - 1) return null;
    return (
      <ArrowButton className="next" onClick={onClick}>
        <MomentsRightArrow color={"#ffffff"}/>
      </ArrowButton>
    );
  };

  const CustomPrevArrow = ({ onClick }) => {
    if (currentSlide === 0) return null;
    return(<ArrowButton className="prev" onClick={onClick}>
      <AdminLeftArrowIcon color={"#ffffff"}/>
    </ArrowButton>
    );
  };



  const deleteMoment = async () => {
    const MomentId = momentId; 
    try {
      const res = await fetchApi(`${DeleteEventMoment}/${MomentId}`, "DELETE");
      window.console.log("delete moment response",res)
      if (res.status ==="success") {
        toast.success(res.message);
        getEventDetailsById(event.id)
        getSharedMoments(companyId, page);
      } else {
        toast.error(res.messgae);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };


  const DeleteModal = (moment) =>{
    window.console.log("moment",moment)
    setMomentId(moment.id);
    setOpenDeleteModal(true);
  }

  const handleDeleteCancel = () =>{
    setOpenDeleteModal(false);
  }

  const handleDeleteConfirm = () =>{
    deleteMoment();
    setOpenDeleteModal(false);
    onClose();
  }

  

  const feedMultiImage = {
    beforeChange: (_, next) => setCurrentSlide(next),
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    draggable: true,
    adaptiveHeight: true,
    nextArrow: <CustomNextArrow />,
    prevArrow: <CustomPrevArrow />,
    responsive: [
      {
        breakpoint: 1252,
        settings: {
          dots: true,
          infinite: true,
          speed: 500,
          draggable: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          dots: true,
          infinite: true,
          speed: 500,
          draggable: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
        },
      },
    ],
  };


  return (
  
    <StyledModal  show={showModal} maxHeight="604px" newWidth="1200px">

      {/* <Modal.Header closeButton={false}  style={{ background: "white" }}>
        <HeaderText style={{width:"100%"}}>
          <div className="subContainer">
            <div className="popupHeading">Moments</div>
            <div className="closeIcon" onClick={()=>{onClose()}}>{CloseIconBranding("#F37A65")}</div>
          </div>
        </HeaderText>
      </Modal.Header>
      <Divider isOpacity={"40%"} isMargin={"0"}></Divider> */}
     
      <StyledBody style={{padding:'0px'}}>
        <MomentImageContainer>
          <div className='imageContainer'>
            <SliderContainer
              display="flex"
              content="center"
              shadow="0px 8px 25px 0px #0D427040"
              maxHeight
              style={{margin:"auto"}}
            >
              <Slider {...feedMultiImage}>
                {
                  modalData?.images?.map((data, index) => (
                    <WrapImage key={index} isBorderRadius={"8px"}  isMomentFill={"contain"}>
                      <img
                        src={`${ImageUrl}/${data}`}
                        alt={"img"}
                        style={{maxHeight:'600px'}}
                      />
                    </WrapImage>
                  ))}
              </Slider>
            </SliderContainer>
          </div>
     
        
          <NewContentV2 isMomentPadding={"0"} newPadding={'newPadding'} style={{ minHeight: 'auto',width:'472px',padding:'16px' }} isMomentMargin={"0"}>
            <div className='user-details' style={{alignItems:'start'}}>
              <div className='row-one'>
                <div className='profile'>
                  {!containsDefaultPng(modalData.moment_owner.profile_image)?
                    <img src={ImageUrl + "/" +modalData.moment_owner.profile_image}/>:
                    <UserInitialsMain font>{`${getInitials(modalData.moment_owner?.post_owner_name)}`}</UserInitialsMain>}
                </div>
                <div className='privacy-admin'>
                  <div className='name'>{modalData.moment_owner?.post_owner_name}</div>
                  <div className="timeLoactionContainer">
                    <div className='location'>{modalData.moment_owner?.location}</div> 
                    {modalData.moment_owner?.location ? <div style={{color:"#BDBDBD"}}>|</div> :null}
                    <div className='location'>{modalData?.time_ago}</div>
                  </div>
                  
                </div>
                
              </div>

              <div className="closeIcon" onClick={()=>{onClose()}} style={{cursor:'pointer'}}>{CloseIconBranding("#F37A65")}</div>
            </div>
            <Divider  isMargin={"0"}></Divider>
            <MomentCaption>{modalData?.text}</MomentCaption>
            <Divider  isMargin={"8px 0p"}></Divider>

            {userId === modalData?.moment_owner?.uid && event?.event_status != "over" ?<ActionContainer>
              <div className='action' onClick={()=>{setSelectedMoment(modalData);setEditMomentModal();}} ><span> {EditIconBranding()}</span> <span className='text'> Edit</span></div>
              <div className='action' onClick={()=> DeleteModal(modalData)} > {DeleteIconBranding()} <span className='text'>Delete</span></div>
              <div className='action' onClick={()=>shareMoment()}>{PostButtonIcon(modalData?.post_id?"#989898":"#F37A65")} <span className='text' style={{color:modalData?.post_id && '#989898'}}>{modalData?.post_id ? 'Shared' : 'Share'}</span></div>

            </ActionContainer>:null}
            {/* {userId === modalData?.moment_owner?.uid && event?.event_status != "over" ? <div>
              <DownAngleV2  feed>
                <DropdownButton id="deleteTour" title={<VerticalDotsIcon/>}>
                  <Dropdown.Item onClick={()=>{setSelectedMoment(modalData);setEditMomentModal();}}>
                    {("Edit moment")}
                  </Dropdown.Item>
                  <Dropdown.Item onClick={()=> DeleteModal(modalData)}>
                    {("Delete moment")}
                  </Dropdown.Item>
                </DropdownButton>
              </DownAngleV2>
            </div>:null} */}
          </NewContentV2>


   
  
        </MomentImageContainer>

      </StyledBody>
      {openDeleteModal && <CommonModal
        show={openDeleteModal}
        icon={RecognitionWarningIcon("#C13D4D")}
        title="Delete Moment"
        description="Are you sure you want to delete this moment?"
        subDescription="This action cannot be undone, and the post will be permanently removed from the system."
        onCancel={handleDeleteCancel}
        onConfirm={handleDeleteConfirm}
        cancelText="Keep moment"
        confirmButtonText="Delete Permanently"
        buttonIcon={AdminDeleteIcon()}
        confirmButtonWidth="198px"
        modalHeight="244px"
        descriptionColor="#CE7841"
        isFontSize={"16px"}
        isPopupMargin={"-10px 0 20px 0"}
      />
      }
    </StyledModal>
  )
}


MomentImagesPopup.propTypes = {
  showModal: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  modalData: PropTypes.object,
  onClick: PropTypes.func,
  userId:PropTypes.number,
  setSelectedMoment:PropTypes.func,
  setEditMomentModal:PropTypes.func,
  event:PropTypes.object,
  getEventDetailsById:PropTypes.func,
  companyId:PropTypes.string,
  page:PropTypes.number,
  getSharedMoments:PropTypes.func,
  shareMoment:PropTypes.func

}


export default MomentImagesPopup;
